import { all, call, put, takeLatest } from 'redux-saga/effects';
import { api } from 'services';
import { history, LOADING, ASYNC_INVOICE_APPROVAL } from 'store';

function* invoiceApproval({ payload }) {
  yield put({ type: LOADING, payload: true });
  try {
    yield payload.append('_method', 'PUT');
    if(payload.get('is_event')){
      yield call(api.post, `event-expense-descriptions/${payload.get('id')}`, payload, {
        headers: {
          'X-Success-Message': 'Nota Fiscal '+(payload.get('status_id')==7?'reprovada':'aprovada')+'!',
          'X-Show-Alert': true
        }
      });
    } else {
      yield call(api.post, `expense-descriptions/${payload.get('id')}`, payload, {
        headers: {
          'X-Success-Message': 'Nota Fiscal '+(payload.get('status_id')==7?'reprovada':'aprovada')+'!',
          'X-Show-Alert': true
        }
      });
    }
    yield call(history.push, `/approve-invoice`, payload);
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

export default function* root() {
  yield all([takeLatest(ASYNC_INVOICE_APPROVAL, invoiceApproval)]);
}
